/* moose.lighting welcome offer
   Two steps: a small yes, then the email. The code is revealed on screen
   rather than emailed, so there is no automation to configure. The address
   still goes to the Shopify customer list with marketing consent.
   Never shown on cart or checkout: interrupting someone mid-purchase to
   mention a discount is how a finished order becomes an abandoned one. */
(function () {
  "use strict";
  var CODE = "LUV250";
  var AMOUNT = "$25";
  var MINIMUM = "$250";
  var KEY = 'moose-offer';
  var DELAY = 5000;
  var SCROLL = 0.30;
  var SNOOZE = 30 * 24 * 60 * 60 * 1000;

  function state() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); }
    catch (e) { return {}; }
  }
  function save(o) {
    try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {}
  }

  var path = (location.pathname || '').toLowerCase();
  if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0) { return; }

  var s = state();
  var joined = !!s.joined;
  var snoozed = s.closed && (Date.now() - s.closed) < SNOOZE;

  var veil, card, tab, opened = false;

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (html !== undefined) { n.innerHTML = html; }
    return n;
  }

  function close(remember) {
    if (!veil) { return; }
    veil.classList.remove('is-on');
    setTimeout(function () { if (veil) { veil.remove(); veil = null; } }, 250);
    if (remember) {
      var o = state(); o.closed = Date.now(); save(o);
    }
    showTab();
  }

  function showTab() {
    if (tab || state().joined) { return; }
    tab = el('button', 'mlp-tab', 'Save ' + AMOUNT);
    tab.setAttribute('type', 'button');
    tab.addEventListener('click', function () { open(true); });
    document.body.appendChild(tab);
  }

  function stepOne() {
    card.innerHTML = '';
    var x = el('button', 'mlp-x', '&times;');
    x.setAttribute('type', 'button');
    x.setAttribute('aria-label', 'Close');
    x.addEventListener('click', function () { close(true); });
    card.appendChild(x);
    card.appendChild(el('p', 'mlp-brand', 'moose.lighting'));
    card.appendChild(el('h2', 'mlp-h', 'Unlock ' + AMOUNT + ' Off'));
    var yes = el('button', 'mlp-btn', 'Accept Offer');
    yes.setAttribute('type', 'button');
    yes.addEventListener('click', stepTwo);
    card.appendChild(yes);
    var no = el('button', 'mlp-no', 'Decline Offer');
    no.setAttribute('type', 'button');
    no.addEventListener('click', function () { close(true); });
    card.appendChild(no);
    card.appendChild(el('p', 'mlp-fine',
      'Minimum order ' + MINIMUM + '. One use per customer.'));
    yes.focus();
  }

  function valid(v) {
    var at = v.indexOf('@');
    var dot = v.lastIndexOf('.');
    return at > 0 && dot > at + 1 && dot < v.length - 1 && v.indexOf(' ') === -1;
  }

  function stepTwo() {
    card.innerHTML = '';
    var x = el('button', 'mlp-x', '&times;');
    x.setAttribute('type', 'button');
    x.setAttribute('aria-label', 'Close');
    x.addEventListener('click', function () { close(true); });
    card.appendChild(x);
    card.appendChild(el('p', 'mlp-brand', 'moose.lighting'));
    card.appendChild(el('h2', 'mlp-h', AMOUNT + ' Off'));
    card.appendChild(el('p', 'mlp-sub',
      'Enter your email and we will show your code right away.'));
    var err = el('p', 'mlp-err', '');
    var input = el('input', 'mlp-in');
    input.setAttribute('type', 'email');
    input.setAttribute('id', 'mlp-email');
    input.setAttribute('placeholder', 'Enter email address');
    input.setAttribute('autocomplete', 'email');
    var go = el('button', 'mlp-btn', 'Show my code');
    go.setAttribute('type', 'button');

    function submit() {
      var v = (input.value || '').trim();
      if (!valid(v)) {
        err.textContent = 'That email address does not look right.';
        input.focus();
        return;
      }
      err.textContent = '';
      go.setAttribute('disabled', 'disabled');
      go.textContent = 'One moment';
      var body = new FormData();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', v);
      body.append('contact[accepts_marketing]', 'true');
      body.append('contact[tags]', 'welcome-offer');
      fetch('/contact', { method: 'POST', body: body })
        .catch(function () {})
        .then(function () {
          var o = state(); o.joined = Date.now(); save(o);
          if (tab) { tab.remove(); tab = null; }
          stepThree();
        });
    }

    go.addEventListener('click', submit);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submit(); }
    });
    card.appendChild(err);
    card.appendChild(input);
    card.appendChild(go);
    var no = el('button', 'mlp-no', 'Decline Offer');
    no.setAttribute('type', 'button');
    no.addEventListener('click', function () { close(true); });
    card.appendChild(no);
    card.appendChild(el('p', 'mlp-fine',
      'Minimum order ' + MINIMUM + '. One use per customer.'));
    input.focus();
  }

  function stepThree() {
    card.innerHTML = '';
    var x = el('button', 'mlp-x', '&times;');
    x.setAttribute('type', 'button');
    x.setAttribute('aria-label', 'Close');
    x.addEventListener('click', function () { close(false); });
    card.appendChild(x);
    card.appendChild(el('p', 'mlp-brand', 'moose.lighting'));
    card.appendChild(el('h2', 'mlp-h', 'Here is your code'));
    var code = el('button', 'mlp-code', CODE);
    code.setAttribute('type', 'button');
    code.setAttribute('title', 'Click to copy');
    code.addEventListener('click', function () {
      try {
        navigator.clipboard.writeText(CODE);
        code.textContent = 'Copied';
        setTimeout(function () { code.textContent = CODE; }, 1400);
      } catch (e) {}
    });
    card.appendChild(code);
    card.appendChild(el('p', 'mlp-sub',
      'Use it at checkout on orders of ' + MINIMUM + ' or more. Shipping is always free.'));
    var go = el('button', 'mlp-btn', 'Start shopping');
    go.setAttribute('type', 'button');
    go.addEventListener('click', function () { close(false); });
    card.appendChild(go);
    code.focus();
  }

  function open(force) {
    if (veil || (opened && !force)) { return; }
    opened = true;
    veil = el('div', 'mlp-veil');
    card = el('div', 'mlp-card');
    veil.appendChild(card);
    veil.addEventListener('click', function (e) {
      if (e.target === veil) { close(true); }
    });
    document.body.appendChild(veil);
    if (state().joined) { stepThree(); } else { stepOne(); }
    /* rAF never fires in a background tab, which would leave an invisible
       full-screen overlay eating every click. Belt and braces. */
    var reveal = function () { if (veil) { veil.classList.add('is-on'); } };
    if (window.requestAnimationFrame) { requestAnimationFrame(reveal); }
    setTimeout(reveal, 40);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && veil) { close(true); }
  });

  if (joined || snoozed) { showTab(); return; }

  function openWhenVisible() {
    if (!document.hidden) { open(false); return; }
    var onShow = function () {
      if (document.hidden) { return; }
      document.removeEventListener('visibilitychange', onShow);
      open(false);
    };
    document.addEventListener('visibilitychange', onShow);
  }

  setTimeout(openWhenVisible, DELAY);
  window.addEventListener('scroll', function once() {
    var h = document.body.scrollHeight - window.innerHeight;
    if (h > 0 && (window.scrollY / h) > SCROLL) {
      window.removeEventListener('scroll', once);
      openWhenVisible();
    }
  }, { passive: true });
})();
